export const AppConfig = {
	APP_ID: "elglobodistrict",
	API_BASE_URL: "https://elglobodistrict.com/platform",
	APP_NOT_VALUE: "--",
	RESET_PASSWORD_MOBILE_APP_URL: "sdistrict://reset_password",
}
